import { render, staticRenderFns } from "./editTravel.vue?vue&type=template&id=28da53ec&scoped=true&"
import script from "./editTravel.vue?vue&type=script&lang=js&"
export * from "./editTravel.vue?vue&type=script&lang=js&"
import style0 from "./editTravel.vue?vue&type=style&index=0&id=28da53ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28da53ec",
  null
  
)

export default component.exports